var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      ref: "dialogRef",
      staticClass:
        "page-dialog center-dialog-no-footer member-detail-v2-dialog",
      attrs: {
        "append-to-body": "",
        visible: _vm.visible,
        width: "80%",
        "close-on-click-modal": false,
      },
      on: {
        close: function ($event) {
          return _vm.emitUpdateVisible(false)
        },
      },
      scopedSlots: _vm._u([
        {
          key: "title",
          fn: function () {
            return [
              _c(
                "div",
                { staticClass: "v2-title" },
                [
                  _c("MemberUidHeader", {
                    attrs: {
                      username: _vm.userInfo.username,
                      uid: _vm.userInfo.uid,
                      "vip-level": _vm.userInfo.vip_level,
                    },
                  }),
                ],
                1
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c(
        "div",
        { staticClass: "v2-body" },
        [
          _c(
            "el-tabs",
            {
              staticClass: "page-tabs",
              attrs: { "tab-position": "top" },
              model: {
                value: _vm.activeTab,
                callback: function ($$v) {
                  _vm.activeTab = $$v
                },
                expression: "activeTab",
              },
            },
            [
              _c(
                "el-tab-pane",
                { attrs: { label: "会员概览", name: "overview" } },
                [
                  _c("ManageOverviewTabV2", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.activeTab === "overview",
                        expression: "activeTab === 'overview'",
                      },
                    ],
                    attrs: {
                      uid: Number(_vm.memberUid) || 0,
                      "user-info": _vm.userInfo,
                    },
                    on: {
                      "status-changed": _vm.reload,
                      "open-bet-history": _vm.openBetHistory,
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-tab-pane",
                { attrs: { label: "提现账号", name: "withdrawAccount" } },
                [
                  _c("ManageWithdrawAccountTabV2", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.activeTab === "withdrawAccount",
                        expression: "activeTab === 'withdrawAccount'",
                      },
                    ],
                    attrs: {
                      uid: Number(_vm.memberUid),
                      "target-info": _vm.targetInfo,
                      "is-active": _vm.activeTab === "withdrawAccount",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-tab-pane",
                { attrs: { label: "账户交易", name: "accountTrade" } },
                [
                  _c("ManageAccountChangeTab", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.activeTab === "accountTrade",
                        expression: "activeTab === 'accountTrade'",
                      },
                    ],
                    attrs: {
                      uid: Number(_vm.memberUid),
                      "is-active": _vm.activeTab === "accountTrade",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-tab-pane",
                { attrs: { label: "投注统计", name: "betStats" } },
                [
                  _c("ManageTransactionInfoTabV2", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.activeTab === "betStats",
                        expression: "activeTab === 'betStats'",
                      },
                    ],
                    attrs: {
                      "target-info": _vm.targetInfo,
                      "is-active": _vm.activeTab === "betStats",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-tab-pane",
                { attrs: { label: "会员日志", name: "memberLogs" } },
                [
                  _c("ManageMemberLogsTabV2", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.activeTab === "memberLogs",
                        expression: "activeTab === 'memberLogs'",
                      },
                    ],
                    attrs: {
                      "target-info": _vm.targetInfo,
                      "is-active": _vm.activeTab === "memberLogs",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }